/**
 * Header Component for 2D Imaging, Inc. Website
 */

class Header extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.innerHTML = `
    <!-- Header -->
    <header>
        <div class="container">
            <div class="header-inner">
                <a href="/" class="logo">2D IMAGING, INC.</a>
                <ul class="nav-links">
                    <li><a href="/" id="nav-home">Home</a></li>
                    <li><a href="/pages/services" id="nav-services">Services</a></li>
                    <li><a href="/collections/all" id="nav-products">Products</a></li>
                    <li><a href="/pages/about" id="nav-about">About</a></li>
                    <li><a href="/pages/careers" id="nav-careers">Careers</a></li>
                    <li><a href="#contact" id="nav-contact">Contact</a></li>
                    <li><a href="/cart" id="nav-cart">Cart (${window.CART_COUNT || 0})</a></li>
                </ul>
                <button class="mobile-menu-btn">☰</button>
            </div>
        </div>
    </header>
    `;

    // Set active nav item based on current page
    const path = window.location.pathname;
    const active = path === "/" ? "home"
      : path.startsWith("/collections") || path.startsWith("/products") ? "products"
      : path === "/cart" ? "cart"
      : path.split("/").pop();
    this.querySelector("#nav-" + active)?.classList.add("active");
  }
}

customElements.define("site-header", Header); 